import { SVGProps } from "react";
const CaretArrowSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      stroke="#7D8690"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.6 16.803 4.8-4.8-4.8-4.8"
    />
  </svg>
);
export default CaretArrowSvg;
